import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api, STAFF_KEY } from "./api";

const Ctx = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  useEffect(() => {
    if (!localStorage.getItem(STAFF_KEY)) {
      setUser(false);
      return;
    }
    api.get("/auth/me").then((r) => setUser(r.data)).catch(() => {
      const cached = localStorage.getItem("sfap_staff_user");
      setUser(!navigator.onLine && cached ? JSON.parse(cached) : false);
    });
  }, []);
  const login = useCallback((token, u) => {
    localStorage.setItem(STAFF_KEY, token);
    localStorage.setItem("sfap_staff_user", JSON.stringify(u));
    setUser(u);
  }, []);
  const logout = useCallback(() => {
    localStorage.removeItem(STAFF_KEY);
    localStorage.removeItem("sfap_staff_user");
    setUser(false);
  }, []);
  return <Ctx.Provider value={{ user, login, logout, setUser }}>{children}</Ctx.Provider>;
}

export const useAuth = () => useContext(Ctx);
